module.exports = __webpack_public_path__ + "static/media/main.0beae592.svg";